import React, { useState } from 'react';
import './Login_page.css';
import { useNavigate } from 'react-router-dom';

function LoginForm({ setShowMessage, setMessage, setError }) {
  const [phoneNo, setPhoneNo] = useState('');
  const [otp, setOtp] = useState('');
  const navigate = useNavigate();

  const handleOTP = async(e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "login",
            "username": phoneNo,
            "phone_number": phoneNo
          }
        })
      });
      const data = await response.json();
      //console.log(data);
      if (data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203) {
        setShowMessage(true);
        setMessage("OTP Sent Successfully");
        setError(false);
      }else{
        setShowMessage(true);
        setMessage("Failed to send OTP, please try again");
        setError(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/login-registration', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "body": {
            "action": "login_validate",
            "username": phoneNo,
            "phone_number": phoneNo,
            "otp": otp
          }
        })
      });
      const data = await response.json();
      //console.log(data);
      if(data.statusCode === 200 || data.statusCode === 201 || data.statusCode === 202 || data.statusCode === 203){
        setShowMessage(true);
        setMessage("Login Successfully");
        setError(false);
        const cleanedBody = data.body.replace(/NaN/g, "null");
        const parsedData = JSON.parse(cleanedBody);
        localStorage.setItem('token',JSON.stringify(parsedData.token));
        navigate('/my-account/address');
      }else{
        setShowMessage(true);
        setMessage("Login Failed Invalid Credentials");
        setError(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className='login-page-form'>
      <h2>Login</h2>
      <p>Welcome back! Sign in to your account.</p>
      <div className='login-page-form-group'>
        <label htmlFor="phone-no">Phone No.</label>
        <input
          type="number"
          id="phone-no"
          onChange={(e) => setPhoneNo(e.target.value)}
        />
      </div>
      <button className='login-page-form-button' disabled={(phoneNo)?false:true} onClick={handleOTP}>Send OTP</button>
      <div className='login-page-form-group'>
        <label htmlFor="otp">OTP</label>
        <input
          type="number"
          id="otp"
          onChange={(e) => setOtp(e.target.value)}
        />
      </div>
      <button className='login-page-form-button' disabled={(otp)?false:true} onClick={handleSubmit}>Login With OTP</button>
    </div>
  );
};

export default LoginForm;